export class StoreSummaryModel {
  public  id: number;
  public  name: string;
  public  code: string;
  public  host_code: string;
  public  description: string;
  public  city: string;
  public  region: string;
  public  address: string;
}

export class StoreModel {
  public id: number;
  public code: string;
  public host_code: string;
  public date_start?: Date;
  public date_end?: Date;
  public name?: string;
  public short_name?: string;
  public description?: string;
  public division_sales_network_id?: number;
  public channel_loyalty_id?: number;
  public country_id?: number;
  public state_id?: number;
  public province_id?: number;
  public toponym_id?: number;
  public city?: string;
  public zip_code?: string;
  public address_number?: string;
  public address_1?: string;
  public address_2?: string;
  public telephone_1?: string;
  public telephone_2?: string;
  public telephone_3?: string;
  public fax?: string;
  public email?: string;
  public contact_1?: string;
  public contact_2?: string;
  public note_1?: string;
  public note_2?: string;
  public note_3?: string;
  public longitude?: number;
  public latitude?: number;
  public altitude?: number;
  public ip_address?: string;
  public flg_graphical_printer?: string;
  public front_end_id?: number;
  public promotion_id?: number;
  public customer_id?: number;
  public loyalty_id?: number;
  public analitics_id?: number;
  public backoffice_id?: number;
  public couponing_id?: number;
  public flg_campaign_candidate?: boolean;
  public company_id?: number;
  public ext_flyer_url?: string;
  public store_surface?: number;
  public checkouts_number?: number;
}

export class StoreGroup {

  public id?: number;
  public code: string;
  public name: string;
}

export class UserStoreDivision {
  public id?: number;
  public user_id: number;
  public username?: string;
  public division_id: number;
  public division_sales_network_id?: number;
  public division_name: string;
  public store_id: number;
  public store_name: string;
  public scope: string;
  public flg_use_preferred_store?: number;
  public store_host_code?: string;

}





// WEBPACK FOOTER //
// ./src/app/models/store-common.model.ts